import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Chart } from 'chart.js';

@Component({
  selector: 'ds-dashboard-chart',
  templateUrl: './ds-dashboard-chart.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class DsDashboardChartComponent implements OnInit {
  @Input() title: string = '';
  @Input() buttonLabel: string = '';
  @Input() buttonClass: string = '';
  @Input() footerItems: Array<{ text: string; indicatorClass?: string }> = [];
  @Input() chartId: string = '';
  @Input() isShowContent: boolean = false;
  @Input() isShowImg: boolean = true;
  @Input() iconSrc: string = '';
  @Input() altText: string = '';
  @Input() responsive: boolean = true;

  @Output() buttonClick = new EventEmitter<void>();

  onButtonClick() {
    this.buttonClick.emit();
  }
  ngOnInit() {
    if ((Chart as any).defaults) {
      (Chart as any).defaults.responsive = this.responsive;
      if ((Chart as any).defaults.global) {
        (Chart as any).defaults.global.responsive = this.responsive;
      }
    }
  }
}
